import Contato from './contato';

export default Contato;